import megatron from '../../../../../utils/megatron/megatron';
import { GI_API_PREFIX, cabsAutoComplete, checkFareHob, hobHoldUrlMMT, provisionalDetailsHob, hobSearchQueryMMT, hobDriverData, hobThankyouApi, hobGetPlaceDetails, hobGetPlaceDetailsMMT, travellerInformationApi, hobUserDetailsApi, hobUserDetailsApiMmt } from '../../../config/constants';
import { filterPredictions, getAddress } from '../utils';

const predictionsCache = new WeakMap();
let SESSION_ID = null;
export const getSessionId = () => {
  if (Boolean(SESSION_ID)) {
    return SESSION_ID;
  } else {
    SESSION_ID = `sessionId_${new Date().getTime().toString(16)}_${Math.floor(
      (1 + Math.random()) * 0x10000,
    )
      .toString(16)
      .substring(1)}`;
  }
  return SESSION_ID;
};

export const getProvisionalDataHOBMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${provisionalDetailsHob}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_prov_hob',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    if (respJson?.error && !respJson?.errors) {
        return {
            errors: {
                error_list: [{
                    code: "PROVISIONAL_API_ERROR_CODE",
                    message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
                }]
            }
        }
    }

    return respJson
  } catch (err) {
    return {
        errors: {
            error_list: [{
                code: "PROVISIONAL_API_ERROR_CODE",
                message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
            }]
        }
    }
  }
}

export const getHoldResponseForHOBMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${hobHoldUrlMMT}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_hold',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getCheckFareHOBMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${checkFareHob}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_check_fare',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const cabsAutoSuggestMmt = async (input = '') => {
  let url = `${__ENV_CONFIG__['__MMT__']}${hobSearchQueryMMT}?query=${input}&tripType=OW&fetchRawData=true&ohl=yes`;

  if (predictionsCache[input]) {
    return predictionsCache[input];
  }

  try {
    const response = await fetch(url);
    const result = await response.json();
    if (!result.success) {
      return [];
    }

    const {res = []} = result;
    const resultsVal = filterPredictions(res, input);
    predictionsCache[input] = resultsVal;
    return resultsVal;
  } catch (err) {
    console.info("err", err);
    return []
  }
}

export const getHOBDriverDataMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${hobDriverData}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_driver_data',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getHOBThankYouDataMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${hobThankyouApi}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_check_fare',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getPlaceDetailsMmt = async (placeId) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${hobGetPlaceDetailsMMT}=${placeId}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json",
    session_id: getSessionId()
  };

  try {
    const response = await megatron({
      name: "cars hob place details",
      type: "GET",
      credentials: 'include',
      url,
      headers
    });
  const results = response?.results || [];
    const [result] = results
    return getAddress(result);
  } catch (err) {
    console.info("err", err);
    return {}
  }
};

export const checkHobUserDetailsMmt = async (request) => {
  const url = `${__ENV_CONFIG__['__MMT__']}${hobUserDetailsApiMmt}`;
  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json",
    session_id: getSessionId()
  };

  const data = {
    ...request
  }

  try {
    const response = await megatron({
      name: "hobUserDetails",
      type: "POST",
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return response

  } catch (err) {
    console.info(err);
    return {}
  }
}

export const getProvisionalDataHOB = async (request) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${provisionalDetailsHob}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_prov_hob',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    if (respJson?.error && !respJson?.errors) {
        return {
            errors: {
                error_list: [{
                    code: "PROVISIONAL_API_ERROR_CODE",
                    message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
                }]
            }
        }
    }

    return respJson
  } catch (err) {
    return {
        errors: {
            error_list: [{
                code: "PROVISIONAL_API_ERROR_CODE",
                message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
            }]
        }
    }
  }
}

export const getHoldResponseForHOB = async (request) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${hobHoldUrlMMT}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_hold',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getCheckFareHOB = async (request) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${checkFareHob}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_check_fare',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export async function cabsAutoSuggest({
  input = '', rf = 'ow'
}) {
  let url = `${__ENV_CONFIG__['__GOCARS__']}/${cabsAutoComplete}`;
  let params = {
    input: input,
    limit: 10,
    media: "source",
    rf: rf,
    vertical: "GoCars",
    flavour: "cars_dweb",
    flow_name: "QuickBook",
    ohl: "yes"
  }

  if (predictionsCache[input]) {
    return predictionsCache[input];
  }

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "Content-Type": "application/json",
    session_id: getSessionId()
  }

  try {
    const respJson = await megatron({
      name: 'cars_prov_autosuggest',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(params),
      headers
    });
    const predictions = respJson?.predictions || []
    const resultsVal = filterPredictions(predictions, input);
    predictionsCache[input] = resultsVal;
    return resultsVal;
  } catch (err) {
    console.info("err", err);
    return []
  }
}

export const getHOBDriverData = async (request) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${hobDriverData}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_driver_data',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getHOBThankYouData = async (request) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${hobThankyouApi}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json',
    session_id: getSessionId()
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatron({
      name: 'cars_hob_check_fare',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return respJson
  } catch (err) {
    console.info("err", err);
    return {}
  }
}

export const getPlaceDetails = async (placeId) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${hobGetPlaceDetails}=${placeId}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json",
    session_id: getSessionId()
  };

  try {
    const response = await megatron({
      name: "cars hob place details",
      type: "GET",
      credentials: 'include',
      url,
      headers
    });
  const results = response?.results || [];
    const [result] = results
    return getAddress(result);
  } catch (err) {
    console.info("err", err);
    return {}
  }
};

export const checkHobUserDetails = async (request) => {
  const url = `${__ENV_CONFIG__["__GOCARS__"]}${hobUserDetailsApi}`;
  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json",
  };

  const data = {
    ...request
  }

  try {
    const response = await megatron({
      name: "hobUserDetails",
      type: "POST",
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });

    return response

  } catch (err) {
    console.info(err);
    return {}
  }
}